export default __webpack_public_path__ + "static/confettis.d016c741db7a20669638a322910b16e3.gif";